export const messageDataParse = (message: any) : { [key: string]: any } => {
    if (typeof message === 'object') {
        return message;
    } else {
        try {
            return JSON.parse(message);
        } catch(e) {
            return {};
        }
    }
};